import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LobbyService } from '../../shared/services/lobby.service';
import { getImpersonateUserDetails } from '../../lobby-staff-status/state/selectors/lobby-staff-status.selector';
import * as LobbyCheckInPageActions from './../state/actions/lobby-check-in-page.actions';
import { Store } from '@ngrx/store';
import { State } from 'src/app/state/app.state';
import { Subscription } from 'rxjs';
import { ImpersonateUserModel } from '../../lobby-staff-status/shared/models/impersonate-user.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getShowImpersonate } from '../state';
@Component({
  selector: 'app-instant-impersonate-assist',
  templateUrl: './instant-impersonate-assist.component.html',
  styleUrls: ['./instant-impersonate-assist.component.scss']
})
export class InstantImpersonateAssistComponent implements OnInit {

  @ViewChild('popupModal') public modal: any;
  
  @Input() public dialogOpened: boolean = false;
  @Input() public message: string = '';
  @Input() public header: string = '';
  @Input() public locationId: number = 0;
  @Input() public lobbyEntry: any = null;
  @Input() public actionYesLabel: string = '';
  @Input() public actionNoLabel: string = '';
  @Input() public isInfo = false;
  @Output() public submitted = new EventEmitter();
  @Output() public cancelled = new EventEmitter();
  @Output() ImpersonateUserSelected = new EventEmitter<{ name: string }>();
  @Output() public locationIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() public lobbyEntryChange: EventEmitter<any> = new EventEmitter<any>();

  userDetails: ImpersonateUserModel[] | null = [];
  lobbyImpersonateForm: FormGroup;
  private subscriptions: Subscription = new Subscription();
  public impersonateAssistUserName: string | null = null;

  public unableToImpersonate: boolean = false;
  public showDifferentPersonRequested: boolean = false;
  public impersonateAssistUserId: number | null = null;

  [key: string]: any;
  
  constructor(public lobbyService: LobbyService, public toastService: ToastService, private store: Store<State>, private fb: FormBuilder) {
    this.lobbyImpersonateForm = this.fb.group({
      assistAsUser: ['-1', [Validators.required, Validators.pattern(/^[1-9]+[0-9]*$/)]],
    });
  }

  ngOnInit() {

    const impersonationUserDetailSubscription = this.store.select(getImpersonateUserDetails)
      .subscribe((userinfo) => {
        this.userDetails = userinfo;
        if (this.userDetails != null && this.userDetails.length < 1 && this.dialogOpened == true) {

          this.unableToImpersonate = true;
          this.dialogOpened = false;
        }
        this.lobbyImpersonateForm.controls.assistAsUser.setValue("-1");
        this.lobbyImpersonateForm.markAsUntouched();


      })
    const promptImpersonationPopupSubscription = this.store.select(getShowImpersonate)
      .subscribe((isShowPopup) => {
        this.dialogOpened = isShowPopup;
        if (this.userDetails != null && this.userDetails.length < 1 && this.dialogOpened == true) {

          this.unableToImpersonate = true;
          this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: false }));
        }


      })
    // this.lobbyService.getImpersonateUserDetails(this.locationId ).subscribe({
    //   next: (userDetails) => {
    //     alert("coming 2...");
    //     console.log(userDetails);
    //    this.userDetails=userDetails;





    //   },
    //   error: () => { this.toastService.showError("Retriving User Details  failed!") }
    // });
    this.subscriptions.add(impersonationUserDetailSubscription);
    this.subscriptions.add(promptImpersonationPopupSubscription);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public close(component: string) {
    this.cancelled.emit();
    this[`${component}Opened`] = false;
    this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: false }));
    this.dialogOpened = false;
  }
  public closeUnableToImpersonate() {
    this.unableToImpersonate = false;
    this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: false }));
  }

  public open(component: string) {
    this[`${component}Opened`] = true;
    this.dialogOpened = true;
  }

  public action(status: string) {
    this.dialogOpened = false;
  }

  public emitSubmit(state: string): void {
    this.impersonateAssistUserId = this.lobbyImpersonateForm.controls.assistAsUser.value;
    const firstName = this.userDetails?.find(x => x.userId == this.impersonateAssistUserId)?.firstName;
    const lastName = this.userDetails?.find(x => x.userId == this.impersonateAssistUserId)?.lastName;
    this.impersonateAssistUserName = firstName + " " + lastName;

    this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: false }));

    if (this.lobbyEntry.personRequestedId != null && this.lobbyEntry.personRequestedId != this.impersonateAssistUserId) {
      this.showDifferentPersonRequested = true;
    } else {
      this.impersonateAssist();
    }


    // this.store.dispatch(CoreActions.updateLobbyLocationSelectorInfo({ payload: { lobbyLocationSelectorInfo: this.locationData } }));
    // this.session.setLobbyLocation(this.locationData);
    this.submitted.emit();
  }

  public impersonateAssist() {
    this.ImpersonateUserSelected.emit({ name: this.impersonateAssistUserName ?? '' });
    this.store.dispatch(LobbyCheckInPageActions.ImpersonateinstantAssist({
      lobbyCheckIn: this.lobbyEntry,
      userId: this.impersonateAssistUserId ?? 0,
      impersonateByName: this.impersonateAssistUserName ?? '',


    }));

    this.showDifferentPersonRequested = false;
  }
  public closeDifferentPersonRequestedPopup() {
    this.showDifferentPersonRequested = false;
  }

  public emitCancel(state: string): void {
    this.cancelled.emit();
    this.store.dispatch(LobbyCheckInPageActions.loadInstantImpersonateAssist({ show: false }));

  }

}
